import React, { useState } from "react";
import InputComponent from "../../components/InputComponents/InputComponent";
import Button from "../../components/Button/Button";
import { contactEnquiry } from "../../../../../utilities/apiRequests/witmegRetailPaxServerRequests";
import { useSelector } from "react-redux";
import { sortByOrderAscending } from "../../helper/helper";
const HopperCafeSubscriptionPage = ({ components, background, message }) => {
    const companyDetails = useSelector((state) => state.companyData.company)
    const [email, setEmail] = useState("")
    const [errors, setErrors] = useState({
        email: ""
    })
    const [loading, setLoading] = useState(false)
    const [showSuccess, setShowSuccess] = useState(false)
    const validateEmail = () => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };
    const validateForm = () => {
        let valid = true;

        const newErrors = {
            email: ""
        };

        const trimmedEmail = email.trim();

        if (trimmedEmail === "") {
            newErrors.email = "*Required";
            valid = false;
        } else if (!validateEmail(trimmedEmail)) {
            newErrors.email = "*Invalid email format";
            valid = false;
        }
        setErrors(newErrors);
        return valid;
    };
    const handleContact = async () => {
        const data = {
            "WebsiteID": companyDetails?.ID || "",
            "Name": "",
            "Email": email,
            "PhoneNo": "",
            "Message": "",
            "Subject": "Hoppers & Latte",
            "OrderID": "",
        }
        if (validateForm() && !loading) {
            setLoading(true)
            let res = await contactEnquiry(data)
            if (res) {
                setEmail("")
                setLoading(false)
                setShowSuccess(true)
                setTimeout(() => {
                    document.querySelector('.succes-alert').classList.add('fade-out');
                    setTimeout(() => {
                        setShowSuccess(false)
                    }, 1000);
                }, 2000);
            } else {
                setLoading(false)
            }
        }
    }
    const getFormComponents = (component) => {
        switch (component.ID) {
            case "HopperCafeSubscriptionPage-input":
                return <InputComponent
                    placeholder={component?.Props?.placeholder}
                    onChange={(e) => {
                        setEmail(e.target.value)
                        setErrors({
                            ...errors,
                            ["email"]: "",
                        });

                    }}
                    value={email}
                    required
                    error={errors.email !== ""}
                    errorText={errors.email} />
            case "HopperCafeSubscriptionPage-button":
                return <Button
                    text={component?.Props?.btnText}
                    width={window.screen.width < 900 ? "100%" : "max-content"}
                    height={component?.Props?.height}
                    isloading={loading}
                    onClick={handleContact}
                />
            default:
                return <div />
        }

    }
    const getFormContent = (component) => {
        return (
            <div className="HopperCafeSubscriptionPage-center-btncont">

                {sortByOrderAscending(component).map((component, key) => {
                    return (
                        getFormComponents(component)
                    )
                })}
            </div>
        )
    }
    const getComponents = (component) => {
        switch (component.ID) {
            case "HopperCafeSubscriptionPage-header":
                return <div className="HopperCafeSubscriptionPage-center-header">
                    {component?.Props?.text}
                </div>
            case "HopperCafeSubscriptionPage-subheader":
                return <div className="HopperCafeSubscriptionPage-center-subheader">
                    {component?.Props?.text1}<br />
                    {component?.Props?.text2}
                </div>
            case "HopperCafeSubscriptionPage-form":
                return getFormContent(component?.Components)
            default:
                return <div />
        }

    }
    return (
        <div className="HopperCafeSubscriptionPage">
            <div className="HopperCafeSubscriptionPage-top" />
            <div className="HopperCafeSubscriptionPage-center"
                style={{ backgroundImage: `linear-gradient(#000000B2, #000000B2),url(${background})` }}>
                {sortByOrderAscending(components).map((component, key) => {
                    return (
                        getComponents(component)
                    )
                })}
                {showSuccess && < div className="succes-alert">
                    {message} </div>}
            </div>
            <div className="HopperCafeSubscriptionPage-bottom" />


        </div>
    )
}
export default HopperCafeSubscriptionPage